import { SignupForm } from 'mk2/apps/users/components/SignupForm';
import { SignupLoginWrapper } from 'mk2/apps/users/components/SignupLoginWrapper';
import { Props } from 'mk2/apps/users/containers/Signup/SignupPage';
import React from 'react';
import styles from './Signup.mscss';

export default class Signup extends React.Component<Props> {

    public render() {
        const { location, onStoreEvent, query, initialValues, mobile, onPrepareUploadPhotos, onVerifySmsToken,
                onSendSmsToken, currentValues, avatar, currentFormPage, onLoadAB, signupVariant } = this.props;

        return (
            <SignupLoginWrapper className={styles.Signup} qs={location.search} mobile={mobile} currentFormPage={currentFormPage}>
                <SignupForm
                    onStoreEvent={onStoreEvent}
                    query={query}
                    simple={false}
                    iframe={false}
                    onSignup={this.handleSignup}
                    onValidateInputs={this.handleValidateInputs}
                    initialValues={initialValues}
                    currentValues={currentValues}
                    onVerifySmsToken={onVerifySmsToken}
                    onSendSmsToken={onSendSmsToken}
                    onPrepareUploadPhotos={onPrepareUploadPhotos}
                    avatar={avatar}
                    onLoadAB={onLoadAB}
                    signupVariant={signupVariant}
                />
            </SignupLoginWrapper>
        );
    }

    private handleSignup = (values) => {
        const { query, onSignup, signupVariant } = this.props;
        const newSignupForm = signupVariant.variant === 'newsignup';
        onSignup(values, query, false, newSignupForm);
    };

    private handleValidateInputs = (values) => {
        const { query, onValidateInputs } = this.props;
        onValidateInputs(values, query);
    };
}
